'use es6';

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import enviro from 'enviro';
import useRecaptcha from './useRecaptcha';
import * as RecaptchaActions from '../../redux/actions/RecaptchaActions';
import { getGoogleActiveLocale } from '../../selectors/LocalizationSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const keys = {
  qa: '6LfqICUbAAAAADgKeRndAwYmtsX4seIp1AE5XJPC',
  prod: '6LeyEyUbAAAAADz_zRM4Vz9jBhl986CKZN2HMPXP'
};
export default function RecaptchaField() {
  const dispatch = useDispatch();
  // use hub-http env check rather than just .getShort() to match localStorage usage for QA custom domains
  const sitekey = keys[enviro.getShort('hub-http')];
  const locale = useSelector(state => getGoogleActiveLocale(state));
  const handleChallengeSuccess = useCallback((...args) => dispatch(RecaptchaActions.handleChallengeSuccess(...args)), [dispatch]);
  const handleRecaptchaExpired = useCallback(() => dispatch(RecaptchaActions.handleRecaptchaExpired()), [dispatch]);
  const updateWidgetId = useCallback(widgetId => dispatch(RecaptchaActions.updateWidgetId(widgetId)), [dispatch]);
  const handleRecaptchaFailure = useCallback((...args) => dispatch(RecaptchaActions.handleRecaptchaFailed(...args)), [dispatch]);
  useRecaptcha({
    sitekey,
    onLoad: updateWidgetId,
    onSuccess: handleChallengeSuccess,
    onExpired: handleRecaptchaExpired,
    onFailure: handleRecaptchaFailure,
    useRecaptchaEnterprise: true,
    locale,
    baseUrl: 'https://www.google.com/recaptcha'
  });
  return /*#__PURE__*/_jsx("div", {
    className: "m-y-4",
    children: /*#__PURE__*/_jsx("div", {
      id: "hsRecaptchaTarget"
    })
  });
}